export default __webpack_public_path__ + "static/media/Slide15.7a06dca4.PNG";